module.exports = __webpack_public_path__ + "img/cer.95f8175f.jpg";